/**
 * In-memory mock store.
 *
 * Submissions and brokerages now hit real backend endpoints (/v2 and
 * /v2/brokerages respectively). The only thing left mocked is the
 * litigation heatmap, which the backend doesn't expose yet.
 */
import type { LitigationApiItem } from "../types/litigation";
import litigationSeed from "./data/litigation.json";

type Store = {
    litigation: LitigationApiItem[];
};

function createStore(): Store {
    return {
        litigation: structuredClone(litigationSeed) as unknown as LitigationApiItem[],
    };
}

const store = createStore();

/** Returns the litigation payload for an application, scaled by the
 *  requested year window. The mock isn't year-aware in the data — we
 *  just trim the row count proportionally so swapping years visibly
 *  changes the response, matching what an API would do. */
export function listLitigation(_applicationId: string, years: number): LitigationApiItem[] {
    const clamped = Math.min(5, Math.max(1, Math.floor(years)));
    const ratio = clamped / 5;
    const limit = Math.max(1, Math.round(store.litigation.length * ratio));
    return structuredClone(store.litigation.slice(0, limit));
}

/** Reset the store back to JSON seeds. Intended for tests. */
export function __resetStore(): void {
    const fresh = createStore();
    store.litigation = fresh.litigation;
}
